// Utilities
import { createSimpleFunctional } from "../../util/index.js";
export const VStepperHeader = createSimpleFunctional('v-stepper-header');
//# sourceMappingURL=VStepperHeader.js.map